import {
  UPDATE_ADD_REQUEST_COUNT,
  UPDATE_SUBTRACT_REQUEST_COUNT
} from "../mutation-types";

export default {
  namespaced: true,
  state: () => ({
    requestCount: 0
  }),
  mutations: {
    // 更新增加记录请求数量
    [UPDATE_ADD_REQUEST_COUNT](state) {
      state.requestCount = state.requestCount + 1;
    },
    // 更新减少记录请求数量
    [UPDATE_SUBTRACT_REQUEST_COUNT](state) {
      state.requestCount = state.requestCount - 1;
      if (state.requestCount < 0) state.requestCount = 0;
    }
  }
};
